<template>
<div class="chapter">
<div class="inner_page">
<h1>Every Move You Make</h1>
<h2 class="sigil_not_in_toc" style="text-align: center;">Jill Jones</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?f28d97f2